module.exports = __webpack_public_path__ + "static/media/cloud-moon.2a923a9f.svg";